
<template>
  <div class="tabber">
    <van-tabbar v-model="Tabactive">
      <van-tabbar-item replace to="/list" icon="home-o">首页</van-tabbar-item>
      <!-- <van-tabbar-item replace to="/msg" icon="chat-o">消息</van-tabbar-item> -->
      <van-tabbar-item replace to="/user" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  props:{
    active: {
      type: Number,
      default: '0',
    }
  },
  data() {
    return {
      Tabactive:this.active
    };
  },
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue